import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as eduActions from 'modules/edu';
import * as currentStatusActions from 'modules/currentStatus';

import { EduDetail, EduTargetDetail } from 'components';

class CtEduDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isClicked: false,
      errorMessage: ''
    };
  }

  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  // 상세보기 보이기/숨기기
  onToggleDetailView = () => {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.onToggleDetailView();
  };

  // 모달 처리
  onToggleModal = viewType => {
    // (태그 추가 모달) 초기화
    const { ReduxFormReset, CurrentStatusActions } = this.props;
    ReduxFormReset('formTagTargetAdd');
    ReduxFormReset('formTagTargetDelete');
    this.setState({ errorMessage: '' });

    CurrentStatusActions.changeTargetTagModal({
      tagNoArray: []
    });

    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  // 아이콘을 통한 스크롤 이동 처리
  onMoveScroll = id => {
    this.scroll.scrollTop(this[id].offsetTop - 15);
  };

  // 스크롤 ref 등록
  onRefRegister = (key, refObject) => {
    if (!!refObject) {
      this[key] = refObject;
    }
  };

  render() {
    const {
      onToggleSnackbar,
      onToggleModal,
      onToggleDetailView,
      onMoveScroll,
      onRefRegister,
      onToggleTargetExam
    } = this;
    const {
      selectEduNo,
      eduSummaryByEduNo,
      eduAttachByAttachNo,
      eduTargetDataByTargetNo,
      isSnackbar,
      isModal,
      selectEduTargetNo
    } = this.props;

    let eduAttachData = false;
    if (selectEduNo !== 'all') {
      const data = eduSummaryByEduNo.get(String(selectEduNo));
      const eduAttachNo = data.get('eduAttachNo');
      eduAttachData = eduAttachByAttachNo.get(String(eduAttachNo));
    }

    const detailComponent = (
      selectEduTargetNo === 0 ?
        <EduDetail
          selectEduNo={selectEduNo}
          eduSummaryByEduNo={eduSummaryByEduNo}
          eduTargetDataByTargetNo={eduTargetDataByTargetNo}
          eduAttachData={eduAttachData}
          isSnackbar={isSnackbar}
          // function
          onToggleSnackbar={onToggleSnackbar}
          onToggleDetailView={onToggleDetailView}
          onMoveScroll={onMoveScroll}
          onRefRegister={onRefRegister}
        />
        :
        <EduTargetDetail
          selectEduNo={selectEduNo}
          eduSummaryByEduNo={eduSummaryByEduNo}
          eduTargetDataByTargetNo={eduTargetDataByTargetNo}
          selectEduTargetNo={selectEduTargetNo}
          onToggleDetailView={onToggleDetailView}
          onMoveScroll={onMoveScroll}
          onRefRegister={onRefRegister}
        />
    );

    return detailComponent;
  }
}

const mapStateToProps = state => ({
  isEditSubmit: state.currentStatus.get('isEditSubmit'),
  isSnackbar: state.currentStatus.get('isSnackbar'),
  isModal: state.currentStatus.get('isModal'),
  selectedTag: state.currentStatus.getIn(['tag', 'selectedTag']),
  tagDataByTagNo: state.tag.get('tagDataByTagNo'),
  eduTargetDataByTargetNo: state.edu.get('eduTargetDataByTargetNo'),
  eduSummaryByEduNo: state.edu.get('eduSummaryByEduNo'),
  eduAttachByAttachNo: state.edu.get('eduAttachByAttachNo'),
  selectEduNo: state.currentStatus.getIn(['edu', 'selectEduNo']),
  selectEduTargetNo: state.currentStatus.getIn(['edu', 'selectEduTargetNo'])
});

const mapDispatchToProps = dispatch => ({
  EduActions: bindActionCreators(eduActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtEduDetail));



// WEBPACK FOOTER //
// ./src/script/containers/edu/CtEduDetail.js